import React, { useState, useEffect } from "react";
import { Col, Form, InputGroup, Row } from "react-bootstrap";
import { IoMdDownload } from "react-icons/io";
import config from "../config.json";
import { v4 as uuidv4 } from "uuid";
import importIcon from "../Images/importIcon.webp";

const metadataTypes = {
  0: "همه دسته‌ها",
  1: "نرم‌افزار",
  2: "قرآن مجید",
  3: "نهج‌البلاغه",
  4: "صحیفه سجادیه",
};
const Post = props => {
  const { post } = props;

  return (
    <div className="list-Item-container" title={post.description}>
      <div className="metaData-list-Items">
        <div className="metaData-list-item-content">
          <span className="font-weight-bold">{post.title}</span>
          <span>-</span>
          <span>
            {post.type === 2 ? " تعداد آیه:" : "تعداد منابع:"}{" "}
            {post.documents_count}
          </span>
        </div>
        <div className="metaData-list-item-icon">
          <span className="metaData-item-type">
            {metadataTypes[post.type] ? `${metadataTypes[post.type]}` : null}
          </span>
          <a
            href={`${config.url}/metadata/download/${post.id}`}
            className="mx-2">
            <span
              title="پس از دانلود فایل را در نرم افزار درون‌برد کنید."
              id={post.id}>
              <IoMdDownload className="metaDAta-download-Button" />
            </span>
          </a>
          <a
            href={`pajoohyar-rdf://${encodeURIComponent(
              config.url,
            )}/metadata/download/${post.id}?title=${encodeURIComponent(
              post.title,
            )}`}
            className="mx-2">
            <span
              title="درون‌برد به نرم‌افزار"
              id={post.id}
              className="downloadButton">
              <img
                src={importIcon}
                alt="downloadImg"
                className="import-program-Icon"
              />
            </span>
          </a>
        </div>
      </div>
      {post.type !== 2 ? (
        post.items_name ? (
          <span style={{ fontSize: "14px" }} className="highlight2">
            {" "}
            شامل: {post.items_name}{" "}
          </span>
        ) : null
      ) : null}
    </div>
  );
};

const MetaDataList = props => {
  const { posts, setField, handleSubmit } = props;
  const [search_term, set_search_term] = useState("");
  const [search_category, set_search_category] = useState("0");

  // eslint-disable-next-line
  useEffect(() => handleSubmit(), [search_category, search_term]);

  return (
    <Form
      className="w-100"
      onSubmit={e => {
        e.preventDefault();
        handleSubmit();
      }}>
      <Row className="px-2 py-3 metaData-controls py-md-2 w-100 mx-0">
        <Col xs={12} md={3} className="mb-3 mb-md-0">
          <Form.Control
            as="select"
            onChange={e => {
              set_search_category(e.target.value);
              setField("type", e.target.value);
            }}>
            {Object.values(metadataTypes).map((metadataType, key) => (
              <option key={uuidv4()} value={key}>{metadataType}</option>
            ))}
          </Form.Control>
        </Col>
        <Col xs={12} md={9} className="matadata-serach-col">
          <InputGroup>
            <Form.Control
              type="text"
              onChange={e => {
                setField("name", e.target.value);
                set_search_term(e.target.value.trim());
              }}
              placeholder="جستجو..."
              className="h-100"></Form.Control>
          </InputGroup>
        </Col>
      </Row>
      <div className="justify-content-center text-center mataData-list d-flex flex-column w-100">
        {posts.length !== 0
          ? posts.slice(0, 12).map(post => <Post key={post.id} post={post} />)
          : "نتیجه ای یافت نشد"}
      </div>
    </Form>
  );
};

export default MetaDataList;
